module.exports = __webpack_public_path__ + "static/media/spring-che-small.b64a1ee3.png";